import { render, staticRenderFns } from "./TDSFoot.vue?vue&type=template&id=7b0dd2b1"
import script from "./TDSFoot.vue?vue&type=script&lang=js"
export * from "./TDSFoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports